<!-- license validity -->
@if (installerAccessUntil() || showLicenseStatus()) {
  <ion-grid class="ion-no-margin ion-margin-top ion-no-padding">
    <ion-row class="ion-margin-vertical ion-no-padding">
      <ion-col
        class="credits ion-padding"
        size-xs="12"
        size-sm="12"
        size-md="12"
      >
        <ion-grid>
          <ion-row>
            <ion-col>
              <p>
                <b>{{ 'installation_until' | translate }}</b>
              </p>
              @if (showUnlimited()) {
                <h2 class="smaller">
                  {{ 'license_unlimited' | translate }}
                </h2>
              } @else if (installerAccessUntil()) {
                <h2 class="smaller">{{ installerAccessUntil() | date }}</h2>
              } @else {
                <h2 class="smaller">—</h2>
              }
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
}

@if (!showUnlimited()) {
  <ng-container>
    <ion-label class="panel-header-text license-options-label" color="dark"
      >{{ optionsLabel() | translate }}
    </ion-label>

    <!-- product overview -->
    <ion-grid class="products ion-no-margin ion-margin-vertical ion-no-padding">
      <ion-row class="ion-no-padding">
        @for (product of filteredProducts(); track product.uid) {
          <ion-col
            (click)="onProductSelected(product)"
            class="product"
            [ngClass]="{ active: product.isSelected }"
            size-xs="12"
            size-sm="12"
            size-md="6"
          >
            <div class="ion-margin ion-padding">
              <h3>{{ product.name | translate }}</h3>
              <h2>€ {{ product.price }}</h2>
              <p [innerHTML]="product.info ?? '' | translate"></p>
            </div>
          </ion-col>
        }
      </ion-row>
    </ion-grid>

    <!-- button to submit selection -->
    @if (showPrevButton()) {
      <ion-button
        type="button"
        class="ion-float-left"
        color="primary"
        (click)="prevClicked.emit()"
      >
        <small>{{ 'general_prev' | translate }}</small>
      </ion-button>
    }
    <ion-button
      type="submit"
      class="ion-float-right"
      color="primary"
      (click)="submitProduct()"
    >
      <small>{{ btnText() | translate }}</small>
    </ion-button>
  </ng-container>
}
